module.exports = __webpack_public_path__ + "media/assets/icons/icon_ins_life-625eef2a6f0b08bca1d598e01229d978.svg";